module.exports = __webpack_public_path__ + "components/StudentActivitySummary/icon-space-120.png";